import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootHeader: {
				background: theme.palette.primary.main,
				height: 95,
				padding: 16,
				transition: "all 1s"
			},
			rootHeaderInput: {
				height: 35,
				position: "fixed",
				width: "100%",
				maxWidth: 444,
				transition: "all 1s"
			},
			headerInput: {
				padding: 16,
				transition: "all 1s",
				background: theme.palette.primary.main
			},
			searchProduct: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			},
			btnNotification: {
				marginLeft: 5,
				cursor: "pointer",
				"&:active": {
					opacity: 0.7
				}
			},
			menu: {
				padding: "16px 16px 6px"
			},
			root: {
				"& > .MuiGrid-item": {
					padding: "5px !important"
				}
			},
			pullToRefresh: {
				"& > div > div": {
					overflow: "hidden !important"
				}
			},
			rootBtn: {
				background: theme.palette.secondary.light,
				borderRadius: 6,
				border: `1px solid ${theme.palette.secondary.main}`,
				height: 40,
				width: "100%",
				"&:active": {
					cursor: "pointer",
					opacity: 0.7
				}
			},
			button: {
				height: 36,
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				fontWeight: 500,
				display: "flex",
				justifyContent: "space-between",
				"& >img": {
					padding: 7
				}
			},
			logo: {
				display: "flex",
				alignItems: "center",
				"& >img": {
					padding: 7
				}
			},
			rootTitle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between"
			},
			title: {
				color: theme.palette.primary.contrastText,
				fontSize: 18,
				fontWeight: 500,
				padding: "5px 16px"
			},
			rootBtnLoyalty: {
				padding: "10px 16px 0px"
			},
			btnLoyalty: {
				cursor: "pointer",
				"& >img": {
					width: "100%",
					borderRadius: 6
				},
				"&:active": {
					opacity: 0.7,
					transition: "width 2s, height 4s",
					transitionTimingFunction: "ease-out"
				}
			},
			infiniteScroll: {
				overflowY: "scroll !important"
			},
			btnScrollProduct: {
				color: theme.palette.primary.contrastText,
				"&:active": {
					background: "none"
				},
				"&:hover": {
					background: "none"
				}
			},
			add: {
				textAlign: "center",
				fontSize: 14,
				fontWeight: 500,
				marginBottom: 20,
				color: theme.palette.primary.contrastText
			}
		}),
	{
		name: "HomePage",
		index: 1
	}
);

export default useStyles;
